export default "__VITE_ASSET__DBQA8NL6__"